import { render, staticRenderFns } from "./summaryTable.vue?vue&type=template&id=ab9b7c1c&scoped=true"
import script from "./summaryTable.vue?vue&type=script&lang=js"
export * from "./summaryTable.vue?vue&type=script&lang=js"
import style0 from "./summaryTable.vue?vue&type=style&index=0&id=ab9b7c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9b7c1c",
  null
  
)

export default component.exports